console.clear();

var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var d3 = {
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min")
};

var $ = require("./lib/qsa");


// Global vars
var pymChild = null;
var renderGraphic = require("./renderGraphic");
var GRAPHIC_WIDTH = null;

// Initialize the graphic.
var onWindowLoaded = function() {
  var data = window.DATA;
  render(data);
  window.addEventListener("resize", () => render(data));

  //  hiding
  if (isMobile.matches){
    var textExtended = $(".excessive");
    textExtended.forEach(function(cell) {
      var button = $.one(".show-more", cell);
      button.addEventListener("click", function() {
        cell.classList.toggle("expanded");
        var expanded = cell.classList.contains("expanded");
        button.innerHTML = expanded ? "Show Less &#9650;" : "Show More &#9660;";

        if (pymChild) {
          pymChild.sendHeight();
        }
      });
    });
  }

  pym.then(child => {
    // var btnPause = document.querySelector('button.play');
    // btnPause.addEventListener('click', playPauseVideo);
    pymChild = child;
    child.sendHeight();
  });
};



// Render the graphic(s). Called by pym with the container width.
var render = function(data,mode) {
  // Render the chart!
  var container = "#map";
  var element = document.querySelector(container);
  var width = element.offsetWidth;

  if (GRAPHIC_WIDTH == null || width != GRAPHIC_WIDTH) {
    GRAPHIC_WIDTH = width;

    renderGraphic({
      container,
      width,
      data
    });
  }

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};


window.onload = onWindowLoaded;
